const API_ENDPOINT = 'https://pure-falls-60303.herokuapp.com/api'

export default API_ENDPOINT
